import { axiosApi } from "../axios";

export const getGraphPeople = async (msUserId: string) => {
  const response = await axiosApi.get(`/users/${msUserId}/people`);

  return response.data;
};

export const searchGraphPeople = async (msUserId: string, search?: string) => {
  const response = await axiosApi.get(`/users/${msUserId}/people?search=${search}`);
  //console.log('request',response.request)
  return response.data;
};
